import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const DeleteFavouriteModal = ({ open, onClose, onSubmit, loading, title }) => (
  <Dialog
    disableRestoreFocus={true}
    open={Boolean(open)}
    onClose={onClose}
    maxWidth="sm" fullWidth>
    <DialogTitle>Remove Favourite</DialogTitle>
    <DialogContent>
      <DialogContentText>Are you sure you want to remove {title} from your favourites?</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button disabled={loading} onClick={onSubmit} color="primary">
        Yes
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteFavouriteModal;

